import type {SVGProps} from 'react'
import {useId} from 'react'

type IconProps = SVGProps<SVGSVGElement> & {
	size?: number
	color?: string
}

export const Basket = ({
												 size = 12,
												 width,
												 height,
												 color = 'currentColor',
												 ...props
											 }: IconProps) => {
	const clipPathId = useId()

	return (
			<svg
					width={width ?? size}
					height={height ?? size}
					viewBox="0 0 12 12"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					{...props}
			>
				<g clipPath={`url(#${clipPathId})`}>
					<path
							d="M10.3638 3.39844C10.6119 3.39844 10.7839 3.14763 10.6909 2.91764C10.3606 2.10105 9.55944 1.52344 8.62583 1.52344H8.19425C8.03331 0.673289 7.28792 0 6.37583 0H5.62583C4.71432 0 3.96845 0.672844 3.80741 1.52344H3.37583C2.44222 1.52344 1.64108 2.10105 1.31078 2.91764C1.21775 3.14763 1.38976 3.39844 1.63785 3.39844H10.3638ZM5.62583 0.703125H6.37583C6.88911 0.703125 7.32481 1.04845 7.47149 1.52344H4.53017C4.67685 1.04845 5.11255 0.703125 5.62583 0.703125ZM2.60363 11.0202C2.64275 11.5696 3.10487 12 3.65565 12H8.34599C8.89677 12 9.35888 11.5696 9.398 11.0202L9.89073 4.10156H2.11093L2.60363 11.0202ZM6.96221 5.98245C6.97192 5.78852 7.13727 5.63897 7.33088 5.64888C7.52481 5.65859 7.67415 5.82366 7.66445 6.01755L7.47695 9.76755C7.46755 9.9555 7.3122 10.1016 7.12611 10.1016C6.92368 10.1016 6.7647 9.93227 6.77469 9.73245L6.96221 5.98245ZM4.67078 5.64888C4.86444 5.63916 5.02977 5.78855 5.03945 5.98245L5.22695 9.73245C5.23693 9.93237 5.07784 10.1016 4.87552 10.1016C4.68943 10.1016 4.53409 9.9555 4.52469 9.76755L4.33719 6.01755C4.32751 5.82366 4.47685 5.65859 4.67078 5.64888Z"
							fill={color}
					/>
				</g>

				<defs>
					<clipPath id={clipPathId}>
						<rect width="12" height="12" fill="white"/>
					</clipPath>
				</defs>
			</svg>
	)
}